export default __webpack_public_path__ + "static/media/HU.1ae32f74.svg";